import React from 'react';
import { GenericTable } from '@wix/seating-common-components';
import { WholeTableReservationWrapper } from '../whole-table-reservation-wrapper';
export var Table = function (_a) {
    var definition = _a.definition;
    return (React.createElement(WholeTableReservationWrapper, { definition: definition },
        React.createElement(GenericTable, { definition: definition })));
};
//# sourceMappingURL=table.js.map